import ApiClient from './ApiClient'

const API_NAME = 'WeConnect'
const BASE_PATH = 'collage'
const client = new ApiClient(API_NAME)

export default {
  /**
   * 最新のコラージュを取得する
   * @param {number} businessId 案件ID
   * @return {Promise<any>} レスポンス
   */
  getLatest(businessId) {
    const query = {}
    query.latest_flag = 'true'
    return client.get(`/business/${businessId}/${BASE_PATH}`, query)
  },

  /**
   * 履歴のコラージュを取得する
   * @param {number} businessId 案件ID
   * @param {number} simulationHistoryId シミュレーション履歴ID
   * @return {Promise<any>} レスポンス
   */
  getHistory(businessId, simulationHistoryId) {
    const query = {}
    query.latest_flag = 'false'
    query.simulation_history_id = simulationHistoryId
    return client.get(`/business/${businessId}/${BASE_PATH}`, query)
  },
}